/**
 * Who the Inspect window is looking at (plan 23 row 34, lane BM). The target
 * frame's Inspect button sets it and opens the window; the window sends the
 * `inspectPlayer` request and renders the server's public reply. A tiny
 * module store (no React, no room) so the HUD and the window share it
 * without a context.
 */
import { windowBridge } from '../../../framework/windowBridge';

export interface InspectTarget {
  /** The other player's session id in this room (never shown, never echoed by the server). */
  sessionId: string;
  /** The name the frame showed, for the title while the reply is in flight. */
  name: string;
}

let current: InspectTarget | null = null;
const listeners = new Set<() => void>();

export function getInspectTarget(): InspectTarget | null {
  return current;
}

export function subscribeInspectTarget(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function setInspectTarget(target: InspectTarget | null): void {
  current = target;
  for (const listener of listeners) listener();
}

/** Inspect another player: remember who, then open (or raise) the window. */
export function openInspect(target: InspectTarget): void {
  setInspectTarget({ ...target });
  windowBridge.open('inspect');
}
